angular.module('filters.stripHtml', []).filter('stripHtml', ['$sce', function($sce){
  return function(val) {
    val = val || '';
    console.log(val);
    return val.replace(/&nbsp;/g, '').trim();
  };
}]);



// WEBPACK FOOTER //
// ./client/src/common/filters/stripHtml.js